import Styles from "./index.module.scss";
import clsx from "clsx";
import { Controller } from "react-hook-form";
import useRePasswordPage from "../../../Hooks/useRePasswordPage";
import { LoginInput } from "../../../Components/Atoms/LoginInput";
import ReCaptcha from "../../../Components/Molecules/ReCaptcha";

function RePassWord() {
  const {
    control,
    handleSubmit,
    isSentVerify,
    handleGetVerifyCode,
    version,
    reCaptchaV2,
    isLoadReCaptChaV3,
    recaptchaLoading,
    recaptchaError,
    isDefaultV3,
    loading,
    isSending,
  } = useRePasswordPage();

  return (
    <div className={clsx(Styles.main)}>
      <div className={clsx(Styles.formBox)}>
        <div className={clsx(Styles.formValue)}>
          <h2>ĐỔI MẬT KHẨU</h2>

          <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
            <Controller
              name="accountName"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="TÀI KHOẢN"
                  id="accountName"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                  isDisable={true}
                />
              )}
            />
            <Controller
              name="password"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="MẬT KHẨU MỚI"
                  id="password"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                  type="password"
                />
              )}
            />

            <Controller
              name="rePassword"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="NHẬP LẠI MẬT KHẨU"
                  id="rePassword"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                  type="password"
                />
              )}
            />

            <Controller
              name="otp"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="MÃ OTP"
                  id="otp"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />

            <ReCaptcha
              version={version}
              isDefaultV3={isDefaultV3}
              reCaptchaV2={reCaptchaV2}
              recaptchaLoading={recaptchaLoading}
              recaptchaError={recaptchaError}
              isLoadReCaptChaV3={isLoadReCaptChaV3}
            />

            <button
              type="submit"
              className={clsx(Styles.btnSubmit, { [Styles.disabled]: loading || isSending })}
              disabled={loading || isSending}
            >
              {loading ? "Đang xác nhận . . ." : "Xác nhận"}
            </button>

            {isSending ? (
              <p>Đang gửi mã xác nhận . . .</p>
            ) : (
              <p onClick={handleGetVerifyCode}>
                {isSentVerify
                  ? "Mã xác nhận đã được gửi !"
                  : "Gửi lại mã xác nhận !"}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
export default RePassWord;
